import { useMemo } from 'react'

export const useObjectUrl = (obj: File | MediaSource) =>
  useMemo(() => {
    if (!obj) {
      return null
    }

    return URL?.createObjectURL(obj)
  }, [obj])
